import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Windows",
  "use": "icon-Windows-usage",
  "viewBox": "0 0 41 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 41 40\" fill=\"none\" id=\"icon-Windows\">\r\n  <path d=\"M18.6555 19.0806V8.43662L7.61719 10.8027V19.0806H18.6555ZM20.4958 19.0806H33.3711V5.28516L20.4958 8.04556V19.0806ZM18.6555 20.9209H7.62047V29.1988L18.6588 31.5649V20.9209H18.6555ZM20.4958 20.9209V31.9592L33.3711 34.7196V20.9209H20.4958Z\" fill=\"#646466\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol